import { AttachmentType } from 'pkg/api/models/attachment';

/**
 *	Pure helpers for uploading a file as an attachment, shared by the legacy
 *	upload (pkg/actions/attachments) and the new app's (actions/attachment).
 */

/** How long reading a video's size may hold up its upload, which goes without it after. */
export const VideoSizeTimeout: number = 1000;

export function typeOfFile(file: File): AttachmentType {
	if (file.type.includes('image')) {
		return AttachmentType.Image;
	}

	if (file.type.includes('video')) {
		return AttachmentType.Video;
	}

	if (file.type.includes('audio')) {
		return AttachmentType.Audio;
	}

	return AttachmentType.File;
}
